import { render, staticRenderFns } from "./JourneySubmit.vue?vue&type=template&id=d67f92bc&lang=pug&"
import script from "./JourneySubmit.vue?vue&type=script&lang=js&"
export * from "./JourneySubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports